import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { BallotCreatorComponent } from './ballot-creator.component';
import { PlayerComponent } from './player/player.component';
import { MatrixComponent } from './matrix/matrix.component';
import { BallotComponent } from './ballot/ballot.component';
import { PlayerCardComponent } from './player-card/player-card.component';

@NgModule({
    imports: [
      IonicModule,
      CommonModule,
      RouterModule
    ],
    declarations: [
        BallotCreatorComponent,
        PlayerComponent,
        MatrixComponent,
        BallotComponent,
        PlayerCardComponent
    ],
    exports: [
        BallotCreatorComponent,
        PlayerComponent,
        MatrixComponent,
        BallotComponent,
        PlayerCardComponent
    ]
  })
  export class BallotCreatorModule { }
